/* Cart-drawer — openen/sluiten, aantallen, verwijderen, toevoegen vanuit "You may also like".
   Na elke mutatie wordt de sectie opnieuw opgehaald (Section Rendering API), zodat prijzen,
   kortingsstaffel en aanbevelingen door Liquid worden berekend en niet in JS worden nagebouwd. */
(function () {
  var root = document.getElementById('cart-drawer');
  if (!root) return;

  var body = root.querySelector('[data-cd-body]');
  var busy = false;

  /* ── openen / sluiten ── */
  function open() {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cd-open');
    var close = root.querySelector('[data-cd-close]');
    if (close) close.focus();
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cd-open');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cd-open], a[href="/cart"], a[href$="/cart"]');
    if (trigger && !trigger.hasAttribute('data-cd-ignore')) {
      e.preventDefault();
      refresh().then(open);
    }
  });

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cd-close]') || e.target.classList.contains('cd-scrim')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  /* ── sectie opnieuw renderen ── */
  function refresh() {
    /* 26-08: de lade zit nu in sectiegroep 'cart-group' zodat hij in de theme editor
       staat. Daardoor is het sectie-id dynamisch — Liquid zet het in data-section-id. */
    var el = root.querySelector('.drawer.cd');
    var sid = (el && el.getAttribute('data-section-id')) || 'cart-drawer';
    return fetch('/?section_id=' + encodeURIComponent(sid), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.drawer.cd');
        if (fresh && body) {
          body.innerHTML = fresh.outerHTML;
          syncCount(fresh.getAttribute('data-cart-count'));
        }
      })
      .catch(function () { /* netwerkfout: drawer laat gewoon de vorige stand zien */ });
  }

  function syncCount(n) {
    document.querySelectorAll('.count, [data-cart-count-bubble]').forEach(function (el) {
      if (el.closest('#cart-drawer')) return;
      el.textContent = n;
    });
  }

  /* ── cart-mutaties ── */
  function post(url, payload) {
    if (busy) return Promise.resolve();
    busy = true;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data && res.data.description ? res.data.description : 'cart error');
        return refresh();
      })
      .catch(function (err) {
        var note = root.querySelector('[data-cd-error]');
        if (note) { note.textContent = err.message; note.hidden = false; }
      })
      .then(function () { busy = false; });
  }

  root.addEventListener('click', function (e) {
    var qty = e.target.closest('[data-cd-qty]');
    if (qty) {
      var line = qty.getAttribute('data-cd-qty');
      var to = parseInt(qty.getAttribute('data-to'), 10);
      var row = qty.closest('.item');
      if (row) row.classList.add('is-busy');
      post('/cart/change.js', { line: parseInt(line, 10), quantity: Math.max(0, to) });
      return;
    }

    var rm = e.target.closest('[data-cd-remove]');
    if (rm) {
      var row2 = rm.closest('.item');
      if (row2) row2.classList.add('is-busy');
      post('/cart/change.js', { line: parseInt(rm.getAttribute('data-cd-remove'), 10), quantity: 0 });
      return;
    }

    var add = e.target.closest('[data-cd-add]');
    if (add) {
      var card = add.closest('[data-cd-rec]');
      var picker = card && card.querySelector('[data-cd-variant]');
      if (!picker || !picker.value) return;
      add.disabled = true;
      post('/cart/add.js', { items: [{ id: parseInt(picker.value, 10), quantity: 1 }] });
      return;
    }

    var prev = e.target.closest('[data-cd-prev]');
    var next = e.target.closest('[data-cd-next]');
    if (prev || next) {
      var track = root.querySelector('[data-cd-track]');
      if (track) track.scrollBy({ left: (next ? 1 : -1) * track.clientWidth, behavior: 'smooth' });
    }
  });

  /* ── openen na 'add to cart' elders op de pagina ── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action$="/cart/add"]')) return;
    e.preventDefault();
    var fd = new FormData(form);
    busy = false;
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function () { return refresh(); })
      .then(open)
      .catch(function () { form.submit(); });
  });

  /* ?cart=open → drawer meteen tonen (handig na een redirect) */
  if (new URLSearchParams(location.search).get('cart') === 'open') {
    refresh().then(open);
  }
})();
